import React, { useState, useEffect, useRef } from 'react';
import html2pdf from 'html2pdf.js';
import ExperiencePDFTemplate from './ExperiencePDFTemplate';


export const ExportToPDF = ({ experienceData }) => {
  const pdfRef = useRef();
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = () => {
      if (timeoutId) clearTimeout(timeoutId);
      
      timeoutId = setTimeout(() => {
        const scrollPosition = window.innerHeight + window.scrollY;
        const documentHeight = document.documentElement.scrollHeight;
        const footerHeight = 70;
        const threshold = 25;
        
        setIsAtBottom(scrollPosition >= documentHeight - footerHeight - threshold);
      }, 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const generatePDF = async () => {
    if (!pdfRef.current || isDownloading) return;
    
    setIsDownloading(true);
    
    try {
      const element = pdfRef.current;

      const opt = {
        margin:       [10, 10, 10, 10],
        filename:     'РЕЗЮМЕ ШИРКО Илья Владимирович.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2, useCORS: true },
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
      };

      await html2pdf().from(element).set(opt).save();
    } catch (error) {
      console.error('Ошибка при генерации PDF:', error);
    } finally {
      setTimeout(() => setIsDownloading(false), 1500);
    }
  };

  return (
    <div>
      {/* Скрытый контейнер для PDF */}
      <div style={{ 
        display: "none",
        position: 'absolute', 
        left: '-9999px',
        width: '794px'
      }}>
        <div ref={pdfRef}>
          <ExperiencePDFTemplate experienceData={experienceData} />
        </div>
      </div>

      {/* Кнопка скачивания */}
      <button 
        className={`downloadResumeButton ${isDownloading ? 'downloading' : ''}`}
        style={{
          bottom: isAtBottom ? '140px' : '40px'
        }}
        onClick={generatePDF}
        disabled={isDownloading}
      >
        {isDownloading ? '⏳ Генерация...' : '📄 Скачать PDF'}
      </button>
    </div>
  );
};